import React, { Component } from "react";
import { auth } from "../../../utils/auth";
import Form from "./Form";
import { apiUrl } from "../../../utils/apiUrl";
import { toast } from "../../../utils/helpers";
import { postRequest } from "../../../utils/request";

class Edit extends Component {
    state = {
        errors: {},
    };
    editTaxonomia = async (event) => {
        event.preventDefault();

        const data = new FormData(event.target);
        const response = await postRequest(
            apiUrl(`taxonomias/${this.props.taxonomia.id}`),
            data
        );

        if (response.success) {
            this.props.getTaxonomias();
            this.props.toggle();
            toast("Categoría actualizada.");
        }

        if (response.code === 422) {
            this.setState({ errors: response.data.message });
        }
    };
    render() {
        const { errors } = this.state;
        const { toggle, taxonomia } = this.props;
        return (
            <form method='post' onSubmit={this.editTaxonomia}>
                <input type='hidden' name='_method' value='patch' />
                <div className='popup__header'>Editar Categoría</div>
                <div className='popup__body'>
                    <Form taxonomia={taxonomia} errors={errors} />
                </div>
                <div className='popup__footer'>
                    <button
                        type='button'
                        onClick={() => toggle({})}
                        className='btn btn-plain'>
                        Cancelar
                    </button>
                    <button type='submit' className='btn btn-primary'>
                        Guardar
                    </button>
                </div>
            </form>
        );
    }
}

export default Edit;
